var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { EventName, Events } from '../utils/events';
import { BaseProvider } from './base';
import { API } from './api';
import { ClassProvider } from './class';
import { DatasetProvider } from './dataset';
import { SettingsProvider } from './settings';
import { BrainBankErrorCode } from './error-code';
var TaggableAsset = /** @class */ (function () {
    function TaggableAsset() {
    }
    return TaggableAsset;
}());
export { TaggableAsset };
export var SHOW_ALL_LABEL = 'Show All';
var AssetProvider = /** @class */ (function (_super) {
    __extends(AssetProvider, _super);
    function AssetProvider(api, classProvider, events, datasetProvider, settingsProvider) {
        var _this = _super.call(this) || this;
        _this.api = api;
        _this.classProvider = classProvider;
        _this.events = events;
        _this.datasetProvider = datasetProvider;
        _this.settingsProvider = settingsProvider;
        _this.uploadModalOpen = false;
        _this.allLockedAssets = [];
        _this.currentAssetIndex = 0;
        _this.saving = false;
        _this.loading = false;
        return _this;
    }
    AssetProvider.prototype.getPolygonsForAsset = function (assetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var polygons, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get("assets/" + assetIdentifier + "/polygons")];
                    case 1:
                        polygons = _a.sent();
                        return [2 /*return*/, polygons];
                    case 2:
                        err_1 = _a.sent();
                        throw err_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AssetProvider.prototype.getAssets = function (datasetIdentifier, limit, offset, sort, order, assets, search, tagged, classIdentifiers) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var params, queryString, result, TaggableAssets, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = [];
                        if (datasetIdentifier) {
                            params.push("datasetIdentifier=" + datasetIdentifier);
                        }
                        if (limit) {
                            params.push("limit=" + limit);
                        }
                        if (offset) {
                            params.push("offset=" + offset);
                        }
                        if (sort) {
                            params.push("sort=" + sort);
                        }
                        if (order) {
                            params.push("order=" + order);
                        }
                        if (assets) {
                            assets.forEach(function (asset) { return params.push("assetIdentifiers[]=" + asset); });
                        }
                        if (search) {
                            params.push("search=" + search);
                        }
                        if (tagged !== null && tagged !== undefined) {
                            params.push("tagged=" + tagged);
                        }
                        if (classIdentifiers) {
                            classIdentifiers.forEach(function (c) {
                                params.push("classes[]=" + c);
                            });
                        }
                        queryString = 'assets' + (params ? '?' + params.join('&') : '');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.loading = true;
                        return [4 /*yield*/, this.api.get(queryString)];
                    case 2:
                        result = _a.sent();
                        TaggableAssets = result.message.assets.map(function (assetObject) {
                            return _this.convertAssetResponseObjectToTaggableAsset(assetObject);
                        });
                        this.assetResults = { assets: TaggableAssets, total: result.message.total };
                        return [2 /*return*/, this.assetResults];
                    case 3:
                        err_2 = _a.sent();
                        throw err_2;
                    case 4:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AssetProvider.prototype.getAsset = function (assetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.get("assets?assetIdentifiers[]=" + assetIdentifier)];
                    case 1:
                        result = _a.sent();
                        if (result.message && result.message.assets && result.message.assets.length > 0 && result.message.assets[0]) {
                            return [2 /*return*/, this.convertAssetResponseObjectToTaggableAsset(result.message.assets[0])];
                        }
                        else {
                            throw new Error("No asset found with identifier: " + assetIdentifier);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AssetProvider.prototype.convertAssetResponseObjectToTaggableAsset = function (assetObject) {
        var asset = new TaggableAsset();
        asset.metadata = assetObject.metadata;
        asset.type = assetObject.type;
        asset.id = assetObject.assetIdentifier;
        asset.name = assetObject.name;
        asset.prefix = assetObject.prefix;
        asset.url = assetObject.signedUrl;
        asset.thumb = assetObject.thumbSignedUrl;
        asset.classCounts = this.processClassCounts(assetObject.classCounts || []);
        return asset;
    };
    /**
     * Get the results of the latest request to the assets endpoint (i.e, getAssets())
     *
     * @returns {AssetResults}
     */
    AssetProvider.prototype.getAssetResults = function () {
        return this.assetResults;
    };
    AssetProvider.prototype.getCurrentAssetIndex = function () {
        return this.currentAssetIndex;
    };
    AssetProvider.prototype.setCurrentAssetIndex = function (assetIndex) {
        if (this.assetResults && assetIndex < this.assetResults.total && assetIndex >= 0) {
            this.currentAssetIndex = assetIndex;
        }
        else {
            // When user is allowed to click on the next asset (arrow), index is incremented, and can go past the range
            // In this case we will go to the first asset index
            this.currentAssetIndex = 0;
        }
    };
    AssetProvider.prototype.isUploadModalOpen = function () {
        return this.uploadModalOpen;
    };
    AssetProvider.prototype.isAssetSaving = function () {
        return this.saving;
    };
    AssetProvider.prototype.isAssetLoading = function () {
        return this.loading;
    };
    AssetProvider.prototype.isIdle = function () {
        return !this.loading && !this.saving;
    };
    AssetProvider.prototype.hasMultipleAssets = function () {
        return this.assetResults.assets && this.assetResults.total > 1;
    };
    AssetProvider.prototype.canGoToPreviousImage = function () {
        return this.isIdle() && this.hasMultipleAssets() && this.currentAssetIndex > 0;
    };
    AssetProvider.prototype.canGoToNextImage = function () {
        return this.isIdle() && this.hasMultipleAssets() && this.currentAssetIndex < this.assetResults.total - 1;
    };
    AssetProvider.prototype.canFinish = function () {
        return !this.assetResults.assets || this.getCurrentAssetIndex() >= this.assetResults.total - 1;
    };
    /**
     * Get the image offset from inside the dataset
     *
     * @params {string} imageIdentifier
     *
     * @returns {number}
     */
    AssetProvider.prototype.getDatasetOffset = function (datasetIdentifier, imageIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var sortOrder, response, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.loadSortOrder(datasetIdentifier)];
                    case 1:
                        sortOrder = _a.sent();
                        return [4 /*yield*/, this.api.get("images/" + imageIdentifier + "/offset?sort=" + sortOrder.sort + "&order=" + sortOrder.order)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response.message.offset];
                    case 3:
                        err_3 = _a.sent();
                        console.warn('Unable to fetch most recently touched asset in dataset');
                        if (err_3 && err_3.error && err_3.error.code === BrainBankErrorCode.AssetNotFound) {
                            console.warn('Fetching first asset in dataset instead');
                            return [2 /*return*/, 0];
                        }
                        else {
                            throw err_3;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AssetProvider.prototype.saveSortOrder = function (datasetIdentifier, sortOrder) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.settingsProvider.mapSet('library.sortOrder', datasetIdentifier, JSON.stringify(sortOrder))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AssetProvider.prototype.loadSortOrder = function (datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var sortOrder;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ensureDependenciesLoaded([this.settingsProvider])];
                    case 1:
                        _a.sent();
                        sortOrder = this.settingsProvider.mapGet('library.sortOrder', datasetIdentifier);
                        if (sortOrder) {
                            return [2 /*return*/, JSON.parse(sortOrder)];
                        }
                        else {
                            return [2 /*return*/, { sort: 'dateAdded', order: 'asc' }];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AssetProvider.prototype.processClassCounts = function (classCounts) {
        var _this = this;
        return classCounts
            .filter(function (cc) {
            return _this.classProvider.getClassByID(cc.classIdentifier) !== undefined;
        })
            .map(function (cc) {
            var classObject = _this.classProvider.getClassByID(cc.classIdentifier);
            return {
                classIdentifier: cc.classIdentifier,
                numPolygons: cc.numPolygons,
                color: classObject.color,
                className: classObject.name
            };
        });
    };
    /**
     * Process a map of classIds to their counts.  There are a couple places
     * in the code that track maps like this.  Process the map and
     * turn it into a ProcessedClassCount array
     *
     */
    AssetProvider.prototype.processClassMapCounts = function (classMap) {
        var classCounts = [];
        for (var classId in classMap) {
            classCounts.push({
                classIdentifier: classId,
                numPolygons: classMap[classId]
            });
        }
        return this.processClassCounts(classCounts);
    };
    /**
     * Saves an exported canvas object to BrainBank
     *
     * @params {string} assetID
     * @params {ExportedPolygon[]} polygons
     */
    AssetProvider.prototype.save = function (assetID, polygons) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!assetID) {
                            throw new Error('No asset identifier found');
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        console.log('Attempting to save image & polygons', assetID, polygons);
                        this.saving = true;
                        return [4 /*yield*/, this.api.post("assets/" + assetID + "/polygons", {
                                polygon: polygons
                            })];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        e_1 = _a.sent();
                        throw e_1;
                    case 4:
                        this.saving = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Rename an asset
     * @param newName
     * @param assetIdentifier
     */
    AssetProvider.prototype.renameAsset = function (newName, assetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("assets/" + assetIdentifier + "/rename", {
                                name: newName
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        throw e_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * lock an asset, if asset already locked, return lock username
     * @param {string} assetIdentifier
     */
    AssetProvider.prototype.lockAsset = function (assetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var resp, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("assets/" + assetIdentifier + "/lock", {})];
                    case 1:
                        resp = _a.sent();
                        if (!this.allLockedAssets.includes(assetIdentifier)) {
                            this.allLockedAssets.push(assetIdentifier);
                        }
                        return [2 /*return*/, resp.message];
                    case 2:
                        error_1 = _a.sent();
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Attempt to extend the lock on an asset; this will
     * throw an error if the user don't already have the lock
     * @param {string} assetIdentifier
     */
    AssetProvider.prototype.renewAssetLock = function (assetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var resp, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.put("assets/" + assetIdentifier + "/lock", {})];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.message];
                    case 2:
                        error_2 = _a.sent();
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Unlock an asset
     * @param {string} assetIdentifier
     */
    AssetProvider.prototype.unlockAsset = function (assetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var resp, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("assets/" + assetIdentifier + "/unlock")];
                    case 1:
                        resp = _a.sent();
                        // When we're just navigating to a new asset or out of the workspace, remove the
                        // unlocked asset from our list, to save time/effort when the user logs out.
                        if (resp.success && this.allLockedAssets.includes(assetIdentifier)) {
                            this.allLockedAssets.splice(this.allLockedAssets.indexOf(assetIdentifier), 1);
                        }
                        return [2 /*return*/, resp.success];
                    case 2:
                        error_3 = _a.sent();
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AssetProvider.prototype.setUploadModalOpen = function (modalOpen) {
        this.uploadModalOpen = modalOpen;
    };
    AssetProvider.prototype.deleteAsset = function (assetIdentifier, datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.delete("assets/" + assetIdentifier)];
                    case 1:
                        _a.sent();
                        this.events.publish(EventName.AssetDeleted, {
                            assetIdentifier: assetIdentifier,
                            datasetIdentifier: datasetIdentifier
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        e_3 = _a.sent();
                        throw e_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Assume there is a previously worked on image in the storage.  If there is, get the identifier
     * and find out where it is in the dataset.
     *
     * If there is no image data stored, it will assume the index is 0
     */
    AssetProvider.prototype.determineActiveDatasetAsset = function (datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var currentAssetID, _a, err_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, this.datasetProvider.getActiveAssetForDataset(datasetIdentifier)];
                    case 1:
                        currentAssetID = _b.sent();
                        if (!currentAssetID) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, this.getDatasetOffset(datasetIdentifier, currentAssetID)];
                    case 2:
                        _a.currentAssetIndex = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.currentAssetIndex = 0;
                        _b.label = 4;
                    case 4: return [2 /*return*/, this.currentAssetIndex];
                    case 5:
                        err_4 = _b.sent();
                        throw err_4;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get a list of all assets that have been marked as locked this session.
     * Please note this will not include assets that were already locked when a user's session began.
     */
    AssetProvider.prototype.getAllLockedAssets = function () {
        return this.allLockedAssets;
    };
    /** Systemically remove all existing locks from the user's images. */
    AssetProvider.prototype.unlockAllLockedAssets = function () {
        var _this = this;
        this.allLockedAssets.forEach(function (asset) { return _this.unlockAsset(asset); });
    };
    AssetProvider.prototype.getItemsPerPageLimit = function (itemsPerPage, total) {
        if (itemsPerPage == SHOW_ALL_LABEL) {
            return total;
        }
        else {
            return Number(itemsPerPage);
        }
    };
    AssetProvider.prototype.incrementCurrentAssetIndex = function () {
        var lastAssetIndex = this.currentAssetIndex - 1;
        // To enable carousel-style / infinite navigation, we need to check whether the user is on the last asset
        // to set the correct asset index
        if (this.currentAssetIndex == lastAssetIndex) {
            this.setCurrentAssetIndex(0);
        }
        else {
            this.setCurrentAssetIndex(this.currentAssetIndex + 1);
        }
    };
    AssetProvider.prototype.decrementCurrentAssetIndex = function () {
        // To enable carousel-style / infinite navigation, we need to check whether the user is on the first asset
        // to set the correct asset index
        if (this.currentAssetIndex == 0) {
            this.setCurrentAssetIndex(this.assetResults.total - 1);
        }
        else {
            this.setCurrentAssetIndex(this.currentAssetIndex - 1);
        }
    };
    AssetProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [API,
            ClassProvider,
            Events,
            DatasetProvider,
            SettingsProvider])
    ], AssetProvider);
    return AssetProvider;
}(BaseProvider));
export { AssetProvider };
//# sourceMappingURL=asset.js.map


// WEBPACK FOOTER //
// ./src/providers/asset.ts.pre-build-optimizer.js